export const SKINNEY_BANNER_EMPTY_DIV_HEIGHT = 71;
export const SKINNEY_BANNER_CATID_EXCLUSION_LIST = [
    'cat1009550004',
    'cat1009550005',
    'cat1009550006',
    'cat1009550007',
    'cat1009550014',
    'cat100240132',
    'cat100240019',
    'cat100240133',
    'cat1002460009',
    'cat1002470003',
    'cat1002460008',
    'cat100240127',
    'cat100240095',
    'cat100330047',
];
export default {
    SKINNEY_BANNER_CATID_EXCLUSION_LIST,
};
